import { render, staticRenderFns } from "./readonlytext.vue?vue&type=template&id=49477487"
import script from "./readonlytext.js?vue&type=script&lang=js&external"
export * from "./readonlytext.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports